/**
 * useFlightLineSchedules — Query hook for flight line data
 *
 * Movement ledger model: fetches upcoming outbound departures and
 * pending inbound return for rendering compact flight lines.
 */

import { useQuery } from '@tanstack/react-query'
import { fetchFlightLineSchedules } from '@/lib/api/aircraft-schedules'

export function useFlightLineSchedules(aircraftId: string | null, locationId: string | null) {
  return useQuery({
    queryKey: ['flight-line-schedules', aircraftId, locationId],
    queryFn: () => fetchFlightLineSchedules(aircraftId!, locationId!),
    enabled: !!aircraftId && !!locationId,
    staleTime: 60_000,
  })
}
